import styled from 'styled-components'

const QuestionsFrameContainer = styled.div`
    padding: 1.6rem 2.8rem;
`
const QuestionDiv = styled.div`
    margin-bottom: 1.2rem;
`

const QuestionText = styled.p`
    font-size: 1.6rem;
    color: ${({ theme }) => `${theme.primary}90`};
`

const QuestionSpan = styled.p`
    font-size: 1.6rem;

    font-weight: bold;
    color: ${({ theme }) => theme.primary};
`

interface QuestionsFrameProsp {
    questions: any[]
}

const QuestionsFrame: React.FC<QuestionsFrameProsp> = ({ questions }) => {
    return (
        <QuestionsFrameContainer>
            {questions.map((question, index) => (
                <QuestionDiv>
                    <QuestionSpan>
                        #{index + 1} {question.question}
                    </QuestionSpan>
                    <QuestionText>{question.answer}</QuestionText>
                </QuestionDiv>
            ))}
        </QuestionsFrameContainer>
    )
}

export default QuestionsFrame
